import { apiClient } from './client';
// User roles API functions
export const userRolesApi = {
    /**
     * Get all user role assignments for a specific company
     */
    getUserRolesByCompany: (clientCompanyId) => apiClient.get(`/api/UserCompanyRoles/Company/${clientCompanyId}`),
    /**
     * Update user company role set. The route carries the tenant
     * (userProfileId + clientCompanyId); the server forces Id from the route (ORB-306).
     */
    updateUserCompanyRoleSet: (userProfileId, clientCompanyId, updateDto) => apiClient.put(`/api/UserCompanyRoles/${userProfileId}/${clientCompanyId}`, updateDto),
    /**
     * Create a new user with initial role assignments
     */
    createUser: (createDto) => apiClient.post('/api/Users/CreateUser', createDto),
    /**
     * Soft delete a user from a client company
     */
    deleteUser: (userProfileId, clientCompanyId) => apiClient.delete(`/api/Users/${userProfileId}/ClientCompany/${clientCompanyId}`),
};
